import React from 'react'
import Modal from '../../../Modal/Modal'

interface TaskBoardsModalProps {
  show: boolean
  onClose: () => void
  availableTaskBoards: Array<{
    id: string
    title: string
    description: string
  }>
  linkedTaskBoards: Array<{
    id: string
  }>
  selectedTaskBoardId: string | null
  setSelectedTaskBoardId: (id: string) => void
  onLinkTaskBoard: () => void
}

export const TaskBoardsModal: React.FC<TaskBoardsModalProps> = ({
  show,
  onClose,
  availableTaskBoards,
  linkedTaskBoards,
  selectedTaskBoardId,
  setSelectedTaskBoardId,
  onLinkTaskBoard
}) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      title='Powiąż tablicę zadań z projektem'
      footer={
        <>
          <button
            className='btn btn__secondary mr-10'
            onClick={onClose}
          >
            Anuluj
          </button>
          <button
            className='btn btn__primary'
            onClick={onLinkTaskBoard}
            disabled={!selectedTaskBoardId}
          >
            Powiąż
          </button>
        </>
      }
    >
      <div style={{ overflowY: 'auto', maxHeight: '250px', paddingBottom: '30px' }}>
        <p>Wybierz tablicę zadań, którą chcesz powiązać z tym projektem:</p>

        {availableTaskBoards.length === 0 ? (
          <p className='mt-10'>Nie masz jeszcze żadnych tablic zadań.</p>
        ) : (
          <div className='mt-10'>
            {availableTaskBoards.map(board => {
              // Sprawdź, czy tablica nie jest już powiązana z projektem
              const isAlreadyLinked = linkedTaskBoards.some(linkedBoard =>
                linkedBoard.id === board.id.toString()
              )

              if (isAlreadyLinked) return null

              return (
                <div
                  key={board.id}
                  className={`card p-15 mb-10 cursor-pointer ${selectedTaskBoardId === board.id.toString() ? 'border-primary' : ''}`}
                  onClick={() => setSelectedTaskBoardId(board.id.toString())}
                  style={{ marginRight: '5px' }}
                >
                  <div className='projectCard'>
                    <h5>{board.title}</h5>
                    <p className='small'>{board.description}</p>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </Modal>
  )
}
